export default {
  "content": "<path d=\"M5.375 15.854l-1.229-1.229L8.771 10 4.146 5.375l1.229-1.229L10 8.771l4.625-4.625 1.229 1.229L11.229 10l4.625 4.625-1.229 1.229L10 11.229l-4.625 4.625z\" fill=\"currentColor\"/>",
  "attrs": {
    "width": "20",
    "height": "20",
    "viewBox": "0 0 20 20",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};